var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fancy-radio-button"},[_c('img',{attrs:{"src":require(("@/assets/ui/radio-button-" + (this.selected ? 'selected' : 'unselected') + ".svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }